import { ProductVariantReducer } from './product-variant.reducer';

export const reducers = ProductVariantReducer;
